// eslint-disable-next-line
export default [
    {
        id: 1,
        bglight: '#F8D5C5',
        bgdark: '#F8D5C5',
        icon: '/svgs/spirits.svg',
        text: 'Whiskey & Rum',
    },
    {
        id: 2,
        bglight: '#E0F1CC',
        bgdark: '#E0F1CC',
        icon: '/svgs/beers.svg',
        text: 'Beers and ciders',
    },
    {
        id: 3,
        bglight: '#FCEDC5',
        bgdark: '#FCEDC5',
        icon: '/svgs/champagne.svg',
        text: 'Champagne',
    },
    {
        id: 4,
        bglight: '#FFC5C2',
        bgdark: '#FFC5C2',
        icon:'/svgs/wine.svg',
        text: 'Wines',
    },
    {
        id: 5,
        bglight: '#FFD1B0',
        bgdark: '#FFD1B0',
        icon:'/svgs/category_vodka.svg',
        text: 'Vodka',
    },
    {
        id: 6,
        bglight: '#C2E9FF',
        bgdark: '#C2E9FF',
        icon:'/svgs/category_gin.svg',
        text: 'Gin & Tequila',
    },
    {
        id: 7,
        bglight: '#E0F1CC',
        bgdark: '#E0F1CC',
        icon:'/svgs/category_flavored.svg',
        text: 'Flavored Drinks',
    },
   
]